import { useQuery } from '@tanstack/react-query';
import { getMyEpcRoles } from '../../../../services/epcProjectService';

/**
 * Returns the EPC project-membership roles the caller holds (across any project).
 * Safe to call when the user is not in EPC context — fails closed to `[]`, no retries.
 *
 * Pass `enabled: false` from non-EPC contexts to skip the request entirely
 * (the sidebar uses this to avoid an extra round-trip outside EPC).
 */
export function useMyEpcRoles(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ['epc', 'me', 'roles'],
    queryFn: getMyEpcRoles,
    staleTime: 5 * 60_000,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: options.enabled !== false,
  });
}
